import { render, staticRenderFns } from "./StrategyBanner.vue?vue&type=template&id=7a4b4739"
import script from "./StrategyBanner.vue?vue&type=script&lang=js"
export * from "./StrategyBanner.vue?vue&type=script&lang=js"
import style0 from "./StrategyBanner.vue?vue&type=style&index=0&id=7a4b4739&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports